import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";

import { Form, Drawer, Button } from "antd";

@inject("rootStore")
@observer
export default class PreviewArticleDrawer extends Component {
	constructor(props) {
		super(props);
	}

	hideDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.hidePreviewArticleDrawer();
	};

	refresh = () => {
		const {
			rootStore: { articleStore }
		} = this.props;
		articleStore.refreshArticleText();
	}

	// getArticle = () => {
	// 	const {
	// 		rootStore: { articleStore }
	// 	} = this.props;

	// 	const article = articleStore.stateForm;

	// 	const title = Spin(article.title.value);		

	// 	const body = Spin(article.body.value);

	// 	const authorName = Spin(article.authorName.value);
	// 	const authorBio = Spin(article.authorBio.value);
		
	// 	const articleText = 
	// 		`<b>${title}</b><br/>
	// 			${body}<br/>
	// 			<b>Name: </b>${authorName}<br/>
	// 			<b>Bio:</b><br/>${authorBio}`;
		
	// 	return articleText;
	// };

	render() {
		const {
			rootStore: { articleStore }
		} = this.props;
		
		const ui = articleStore.ui;		
		const previewArticleDrawerVisible = ui.previewArticleDrawerVisible;

		// const articleText = getArticle();

		return (
			<Drawer
				title="Preview Article"
				placement="top"
				closable={false}
				onClose={this.hideDrawer}
				visible={previewArticleDrawerVisible}
				height="100%"				
				bodyStyle={{ overflow: "scroll", height: 600 }}
			>
				<div dangerouslySetInnerHTML={{ __html: ui.articleText }} />
				<div
					style={{
						position: "absolute",
						bottom: 0,
						width: "100%",
						borderTop: "1px solid #e8e8e8",
						padding: "10px 16px",
						textAlign: "left",
						left: 0,
						background: "#fff",
						borderRadius: "0 0 4px 4px"
					}}
				>
					<Button
							style={{
								marginRight: 8
							}}
							type="primary"
							onClick={this.refresh}
						>
							Refresh
					</Button>
					<Button
						style={{
							marginRight: 8
						}}
						onClick={this.hideDrawer}
					>
						Close
					</Button>
				</div>
			</Drawer>
		);
	}
}
